import { connect } from 'react-redux';
import withLocalLoader from '../../components/HOCs/withLocalLoader';
import DashboardCommissionReco from './DashboardCommissionReco';

export default connect(null)(
  withLocalLoader(
    DashboardCommissionReco,
    false,
    'CustomersCommissionsReco',
    'CustomersCommissionsReco'
  )
);
